<template>
  <div v-if="isRelevant" class="wt-asset-preview-video-transcript">
    <span class="wt2-text-n2">Transcript</span>

    <div class="-right-panel">
      <div v-if="transcribing" class="-process-indicator">
        <transcribe-animation />
        Transcribing
        <wt-ellipsis-animation />
      </div>
      <div v-else class="wt2-color-link wt2-text-n" @click="$_onEditTranscript">
        Edit
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { isAssetCandidateForTranscribe } from 'v/Story/Timeline/api/transcription';
import wtTranscribe from 'v/Transcribe/Transcribe.vue';
import TranscribeAnimation from 'AssetEditor/functionality/Animation/TranscribeAnimation.vue';

export default {
  name: 'AssetPreviewVideoTranscriptControls',
  components: {
    TranscribeAnimation,
  },

  props: {
    asset: { type: Object, required: true },
  },

  computed: {
    ...mapState({
      transcriptions: (state) => state.story.transcriptions,
    }),
    ...mapState('assetEditor', ['openedFrom']),

    isRelevant() {
      const isRelevantView =
        /lightbox|original-video|timeline-change-segment/.test(this.openedFrom);
      return isRelevantView && this.isAssetCandidateForTranscribe;
    },

    isAssetCandidateForTranscribe() {
      return isAssetCandidateForTranscribe(this.$props.asset);
    },

    currentTranscript() {
      return this.transcriptions[this.$props.asset.metadata.assetUUID];
    },

    transcribing() {
      return /PENDING|PROCESSING/.test(this.currentTranscript?.status);
    },
  },

  methods: {
    $_onEditTranscript() {
      this.$root.$emit('pause-video');

      this.mixinShowViewInModal({
        type: 'custom',
        component: wtTranscribe,
        showCloseButton: false,
        closeOnEscape: true,
        wrapperClass: ['wt-transcribe-modal'],
        store: this.$store,
        componentPropsData: {
          opener: app.TRANSCRIPT_OPENER.LIGHTBOX_PREVIEW,
          list: [
            {
              assetUUID: this.$props.asset.metadata.assetUUID,
              transcribeSubType: app.transcribeSubType.VIDEO,
              timeLimit: false, // {startTime: 0, endTime: 1},
            },
          ],
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wt-asset-preview-video-transcript {
  display: flex;
  justify-content: space-between;

  .-right-panel {
    position: relative;

    .-process-indicator {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-right: 15px;

      .wt-transcribe-animation {
        margin-right: 5px;
      }
    }
  }
}
</style>
